import FinancialReviewFormEdit from 'features/FinancialReview/pages/Edit';
import Layout from 'layout';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function FinancialReviewFormEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <FinancialReviewFormEdit />
      </Layout>
    </LayoutProvider>
  );
}
